import * as yup from "yup";

export interface SigninAuthValues {
  email: string;
  password: string;
}

export const emptySigninFormValue: SigninAuthValues = {
  email: "",
  password: "",
};

export const signinSchema: yup.Schema<SigninAuthValues> = yup.object({
  email: yup
    .string()
    .required("Email is required")
    .email("Invalid email")
    .matches(/@[^@]+\.[^@.]+$/, "Enter a complete email address"),
  password: yup.string().required("Password is required"),
});

export interface SignupAuthValues {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export const emptySignupFormValue: SignupAuthValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  confirmPassword: "",
};

export const signUpSchema: yup.Schema<SignupAuthValues> = yup.object({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  email: yup
    .string()
    .required("Email is required")
    .email("Invalid email")
    .matches(/@[^@]+\.[^@.]+$/, "Enter a complete email address"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>/]/,
      "Password must contain at least one symbol",
    ),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

export interface WorkSpaceNameValues {
  businessName: string;
}

export const emptyWorkSpaceNameValue: WorkSpaceNameValues = {
  businessName: "",
};
export const workSpaceNameSchema: yup.Schema<WorkSpaceNameValues> = yup.object({
  businessName: yup.string().required("Business name is required"),
});

export interface ForgotPasswordValues {
  email: string;
}

export const emptyForgotPasswordValue: ForgotPasswordValues = {
  email: "",
};

export const forgotPasswordSchema: yup.Schema<ForgotPasswordValues> =
  yup.object({
    email: yup
      .string()
      .required("Email is required")
      .email("Invalid email")
      .matches(/@[^@]+\.[^@.]+$/, "Enter a complete email address"),
  });

export interface ResetPasswordValues {
  password: string;
  confirmPassword: string;
}

export const emptyResetPasswordValue: ResetPasswordValues = {
  password: "",
  confirmPassword: "",
};

export const resetPasswordSchema: yup.Schema<ResetPasswordValues> = yup.object({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>/]/,
      "Password must contain at least one symbol",
    ),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password")], "Passwords must match"),
});

export interface SigninVerificationValues {
  code: string;
  trustDevice: boolean;
}

export const emptySigninVerificationValues: SigninVerificationValues = {
  code: "",
  trustDevice: false,
};

export const signinVerificationSchema: yup.Schema<SigninVerificationValues> =
  yup.object({
    code: yup
      .string()
      .required("Enter the verification code")
      .matches(/^[0-9]{6}$/, "Enter a valid 6-digit code"),
    trustDevice: yup.boolean().required(),
  });
